import React from 'react';
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';

export default function Save({attributes}) {
	return (
		<div { ...useBlockProps.save() } >
			<div className='casaca-blocks-page'>
				<InnerBlocks.Content />
			</div>
		</div>
	);
}
